module.exports = __webpack_public_path__ + "img/bg-banner-login.784b55b0.svg";